import React from 'react';
import { SmartDataTable } from '@src/components/SmartDataTable';
import { usePaymentsColumns } from './hooks/usePaymentsColumns';
import { usePaymentsFormFields } from './hooks/usePaymentsFormFields';

export const PaymentsPage: React.FC = () => {
  const columns = usePaymentsColumns();
  const formFields = usePaymentsFormFields();

  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <SmartDataTable
        api={{
          resource: 'payments',
        }}
        title="Payments"
        columns={columns}
        search={{
          enabled: true,
          fields: ['id', 'reference_id', 'amount'],
          placeholder: 'Search by ID, reference ID, amount...',
          debounceMs: 500,
        }}
        createForm={{
          fields: formFields as any,
          title: 'Create Payment',
          submitText: 'Create Payment',
        }}
        editForm={{
          fields: formFields as any,
          title: 'Edit Payment',
          submitText: 'Save Changes',
        }}
        formDisplayMode="modal"
        drawerWidth={600}
        showCreate={true}
        showEdit={true}
        showDelete={true}
        showView={false}
        pageSize={10}
        showSizeChanger={true}
        showQuickJumper={false}
        // showExport={true}
        // requireFiltersForExport={true}
        showColumnVisibility={true}
        tableProps={{
          scroll: {
            x: 'max-content',
            y: 'calc(100vh - 240px)',
          },
        }}
        rowKey="id"
        style={{
          height: '100%',
        }}
      />
    </div>
  );
};
